<template>
  <div>
    <item-desc :fields="fields" :data="data" :label-width="150">
      <template slot="gender" slot-scope="{ field }">
        <Tag v-if="field === 1" color="primary">男</Tag>
        <Tag v-else-if="field === 2" color="warning">女</Tag>
        <Tag v-else color="default">未知</Tag>
      </template>
      <template v-if="field" slot="label" slot-scope="{ field }">
        <Tag v-for="item in field.split(',')" :key="item" :name="item" color="warning">{{ item }}</Tag>
      </template>
    </item-desc>
  </div>
</template>

<script>

import pageTable from '../../../components/pageTable/index'
import itemDesc from '../../../components/item-desc/index'
import { getMemberDetail } from '../../../api/member'
export default {
  name: 'detail',
  components: { pageTable, itemDesc },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      fields: [
        { key: 'username', label: '用户名', type: 'text', clearable: true, readonly: 'readonly', span: 12 },
        { key: 'avatar', label: '头像', type: 'avatar', clearable: true, readonly: 'readonly', span: 12 },
        { key: 'nickname', label: '昵称', type: 'text', span: 12 },
        { key: 'gender', label: '性别', type: 'slot', span: 12 },
        { key: 'mobile', label: '手机号', type: 'text', span: 12 },
        { key: 'wechat', label: '微信', type: 'text', span: 12 },
        { key: 'last_login_ip', label: '最后登录IP', type: 'text', span: 12 },
        { key: 'register_ip', label: '注册IP', type: 'text', span: 12 },
        { key: 'follow_count', label: '关注数', type: 'text', span: 12 },
        { key: 'fans_count', label: '粉丝数', type: 'text', span: 12 },
        { key: 'liked_count', label: '点赞数', type: 'text', span: 12 },
        { key: 'identity', label: '身份证号码', type: 'text', span: 12 },
        { key: 'realname', label: '身份证姓名', type: 'text', span: 12 },
        { key: 'login_time', label: '最后登录时间', type: 'text', span: 12 },
        { key: 'joined_time', label: '付费加入时间', type: 'text', span: 12 },
        { key: 'create_time', label: '创建时间', type: 'text', span: 12 },
        { key: 'update_time', label: '更新时间', type: 'text', span: 12 },
        { key: 'province', label: '省份', type: 'text', span: 12 },
        { key: 'city', label: '城市', type: 'text', span: 12 },
        { key: 'country', label: '国家', type: 'text', span: 12 },
        { key: 'company_name', label: '公司名称', type: 'text', span: 12 },
        { key: 'company_abbreviation', label: '公司简介', type: 'text', span: 12 },
        { key: 'position', label: '职位', type: 'text', span: 12 },
        { key: 'company_address', label: '公司地址', type: 'text', span: 12 },
        { key: 'label', label: '标签', type: 'slot', span: 12 },
        { key: 'signature', label: '个性签名', type: 'textarea', span: 24 }
      ],
      data: {

      },
      tableLoading: false
    }
  },
  watch: {
    id (val, old) {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.tableLoading = true
      getMemberDetail({ id: this.id }).then(({ data }) => {
        this.data = data
      }).finally(() => {
        this.tableLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
